var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    _vm.component,
    _vm._g(
      _vm._b(
        {
          directives: [
            {
              name: "fusioninputcheck",
              rawName: "v-fusioninputcheck",
              value: _vm.fusioninputcheck,
              expression: "fusioninputcheck",
            },
          ],
          tag: "component",
          model: {
            value: _vm.proxyValue,
            callback: function ($$v) {
              _vm.proxyValue = $$v
            },
            expression: "proxyValue",
          },
        },
        "component",
        _vm.$attrs,
        false
      ),
      _vm.$listeners
    ),
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }